<template>
  <carousel
    class="carousel"
    paginationActiveColor="#3a65f0"
    paginationColor="#adaeaf"
    :perPageCustom="[
      [0, 1],
      [769, 2],
      [1025, 3],
    ]"
  >
    <slide>
      <home-customer-quotes-item
        :quote="$t('home.customer.quotes.item-1.quote')"
        :customer="$t('home.customer.quotes.item-1.customer')"
      />
    </slide>
    <slide>
      <home-customer-quotes-item
        :quote="$t('home.customer.quotes.item-2.quote')"
        :customer="$t('home.customer.quotes.item-2.customer')"
      />
    </slide>
    <slide>
      <home-customer-quotes-item
        :quote="$t('home.customer.quotes.item-3.quote')"
        :customer="$t('home.customer.quotes.item-3.customer')"
      />
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import HomeCustomerQuotesItem from '@/components/home/HomeCustomerQuotesItem.vue';

export default {
  components: {
    Carousel,
    Slide,
    HomeCustomerQuotesItem,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

.carousel {
  display: flex;
  max-width: $page-laptop-breakpoint;
}

@media (max-width: $page-laptop-breakpoint) {
  .carousel {
    max-width: $page-table-breakpoint;
  }
}

@media (max-width: $page-table-breakpoint) {
  .carousel {
    max-width: $page-mobile-large-breakpoint;
  }

  .VueCarousel-slide.VueCarousel-slide-active.VueCarousel-slide-center {
    display: flex;
    justify-content: center;
  }
}

@media (max-width: $page-mobile-large-breakpoint) {
  .carousel {
    max-width: $page-mobile-small-breakpoint;
  }
}
</style>
